var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headerActionConfig,
          "left-side-class": "col-xl-5 pb-2",
          page: _vm.headerConfig,
          "right-side-class":
            "col-xl-7 d-flex align-items-end pb-4 justify-content-end"
        }
      }),
      _c("question-form", {
        attrs: { id: _vm.id, "is-preview": "", "is-read-only": "" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }